import React from "react";
import './styles.css'

export const MensagemGraficoVazio = () => {
    return (
        <div className="container-mensagem-grafico-vazio">
            <p className="mensagem-grafico-vazio">Dados insuficientes para gerar Gráfico.</p>
        </div>
    )
}